export const initialsPicture = (name?: string) => {
  const nameArray = name?.split(' ') || []
  const fullName = nameArray[0]
  const lastName =
    nameArray.length > 1 ? nameArray[nameArray.length - 1] : undefined

  return `https://ui-avatars.com/api/?name=${fullName}+${lastName}&background=random&size=512&length=${lastName ? 2 : 1}`
}
